import React, { useCallback } from 'react';
import { IntlShape, useIntl } from 'react-intl';
import { camelCase } from 'lodash-es';

import { Switch } from '../../../../../interfaces/merchants/resources/books';
import BooksTypeRadio from '../common/buttons/BooksTypeRadio';
import css from './InputBookingTargetSwitch.module.scss';

interface Props {
  intl: IntlShape;
  selected: Switch;
  onClick: (select: Switch) => void;
}

const InputBookingTargetSwitch: React.FC<Props> = ({ selected, onClick }) => {
  const intl = useIntl();
  const handleClick = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const selections = Object.values(Switch);
      const selection = selections.find((s) => s === e.currentTarget.value)!;
      onClick(selection);
    },
    [onClick],
  );

  const selections = Object.values(Switch);

  return (
    <div className={css.InputBookingTargetSwitch}>
      {selections.map((selection) => (
        <BooksTypeRadio
          key={selection}
          name="switch"
          id={selection}
          value={selection}
          label={intl.formatMessage({
            id: `books.button.${camelCase(selection)}`,
          })}
          onChange={handleClick}
          checked={selection === selected}
        />
      ))}
    </div>
  );
};

export default InputBookingTargetSwitch;
